import Vue from "vue"
import Chartkick from "vue-chartkick"
import Chart from "chart.js"

Vue.use(Chartkick.use(Chart))
